import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

function Btnloader() {
  return <CircularProgress color={"primary"} size={30} />;
}

export default Btnloader;

